import React, { Fragment, useContext } from 'react';
import Form from 'react-bootstrap/Form';
import LocaleContext from 'constants/localization';

// converts bytes to kb / mb / gb..
function formatBytes(a,b=2){if(0===a)return'0 Bytes';const c=0>b?0:b,d=Math.floor(Math.log(a)/Math.log(1024));return parseFloat((a/Math.pow(1024,d)).toFixed(c))+' '+['Bytes','KB','MB','GB','TB','PB','EB','ZB','YB'][d];}

const FileInput = ({file, setFile, label}) => {
  const LS = useContext(LocaleContext);

  return (
    <Fragment>
      <label>{label}</label>
      <Form.File
        id="file"
        data-browse={LS.actions.choose}
        custom
        onChange={e => setFile(e.target.files[0])}
      />
      {
        file &&
        <span>
          {formatBytes(file.size)}
        </span>
      }
    </Fragment>
  );
};

export default FileInput;